/**
 * internal dependencies
 */
import { VEHICLE_POOL_FORM } from "../form-cardgroup-types";
import WarningModalControl from "../../../modal/warning-modal";

/**
 * Check if the user Pin Pool checkbox is checked.  If it is, then
 * enable the Pin Pool fields.  If it is not, then disable the Pin Pool fields.
 * 
 * @param {HTMLInputElement} pinPoolCheckBox - the checkbox element
 * 
 * @returns void 
 */
export const useVehiclePin = (pinPoolCheckBox: HTMLInputElement) => { 
  VEHICLE_POOL_FORM.vpActiveWarning.classList.toggle('aafp_display-none', !pinPoolCheckBox.checked);
  //pinPoolCheckBox.checked ? VEHICLE_POOL_FORM.vpExport.removeAttribute('disabled') : VEHICLE_POOL_FORM.vpExport.setAttribute('disabled', 'true');
  VEHICLE_POOL_FORM.vpOptionalFields.forEach(field => field.classList.toggle('aafp_pin-disabled', !pinPoolCheckBox.checked));

  if ( !pinPoolCheckBox.checked && VEHICLE_POOL_FORM.vpFieldContainer.children.length > 0 ) {
    WarningModalControl(VEHICLE_POOL_FORM.vpModal, VEHICLE_POOL_FORM.vpCardGroupName.value);
  }  
};

/**
 * Check if the Pin Number already exists in the Pin Pool
 * 
 * @param {HTMLInputElement} currentPinNumberField - the current pin number field
 * 
 * @returns void
 */
export const checkForUniquePin = ( currentPinNumberField: HTMLInputElement ) => {
  let isValid = false;
  if (currentPinNumberField.value.length >= 49) {
    currentPinNumberField.value = currentPinNumberField.value.slice(0, 49);
    currentPinNumberField.classList.add('invalid-pins');
    VEHICLE_POOL_FORM.vpSubmitButton.setAttribute('disabled', 'true');
    VEHICLE_POOL_FORM.vpErrorTwo.textContent = 'Pin Number cannot be greater than 49 characters';
  } else if ( currentPinNumberField.valueAsNumber < 0 ) {
    currentPinNumberField.classList.add('invalid-pins');
    VEHICLE_POOL_FORM.vpSubmitButton.setAttribute('disabled', 'true');
    VEHICLE_POOL_FORM.vpErrorTwo.textContent = 'Pin Number cannot be less than 0';
  } else if ( currentPinNumberField.value.length < 4 ) {
    currentPinNumberField.classList.add('invalid-pins');
    VEHICLE_POOL_FORM.vpSubmitButton.setAttribute('disabled', 'true');
    VEHICLE_POOL_FORM.vpErrorTwo.textContent = 'Pin Number cannot be less than 4 characters';
  } else {
    isValid = true;
    VEHICLE_POOL_FORM.vpSubmitButton.removeAttribute('disabled');
    currentPinNumberField.classList.remove('invalid-pins');
    VEHICLE_POOL_FORM.vpErrorTwo.textContent = '';
  }  

  if (isValid) {
    let error = document.querySelectorAll<HTMLInputElement>('.invalid-pins');
    error.forEach(err => {
      err.classList.remove('invalid-pins');
      VEHICLE_POOL_FORM.vpError.textContent = '';
      VEHICLE_POOL_FORM.vpSubmitButton.removeAttribute('disabled');
    });

    const pinNumbers = Array.from(document.querySelectorAll<HTMLInputElement>('[data-pin]'));

    let valueGroup = pinNumbers.filter(pin => pin.dataset.pin === currentPinNumberField.value);

    if (valueGroup.length === 0) return;
    let ele = valueGroup.reduce((acc, curr) => {
      if (acc.dataset.pin === curr.dataset.pin) {
        acc.classList.add('invalid-pins');
        curr.classList.add('invalid-pins');
        VEHICLE_POOL_FORM.vpError.textContent = 'Pin Number already exists';
        VEHICLE_POOL_FORM.vpSubmitButton.setAttribute('disabled', 'true');
      }
      
      return acc;
    });
  }
};